import type { TourConfig, DemoTourConfig } from '@components/tours/types';

// Import from colocated folders
import * as batch from './machines/batch';
import * as planboard from './planboard';
import * as wallboard from './wallboard';

// Re-export individual tours for backwards compatibility
export const batchGeneralTour = batch.tourConfig;
export const planboardOverviewTour = planboard.tourConfig;
export const wallboardOverviewTour = wallboard.tourConfig;

// Tour registry for TourProvider
export const tourConfigs: Record<string, TourConfig> = {
  'batch-general': batch.tourConfig,
  'planboard-overview': planboard.tourConfig,
  'wallboard-overview': wallboard.tourConfig,
};

// Demo data registry (built from same imports)
export const demoDataRegistry: Record<string, DemoTourConfig> = {
  ...(batch.demoConfig ? { 'batch-general': batch.demoConfig } : {}),
  ...(planboard.demoConfig ? { 'planboard-overview': planboard.demoConfig } : {}),
  ...(wallboard.demoConfig ? { 'wallboard-overview': wallboard.demoConfig } : {}),
};

export const getDemoConfig = (tourId: string): DemoTourConfig | undefined => demoDataRegistry[tourId];
export const hasDemoConfig = (tourId: string): boolean => tourId in demoDataRegistry;

// Global tour exports
export { globalTourConfigs, createWelcomeTour } from './global';

export default tourConfigs;
